import { isNil } from 'lodash';
import { CohortSampleTableColumnType } from '../../../utils/apollo/graphqlSchema';
import { formatNumberWithComma } from '../../../utils/formatText';
import { colorAlpha } from '../../../utils/colorAlpha';

const getOpacityBasedOnDeviation = (value: number) => {
  let deviation = 0;

  if (value) {
    deviation = Math.abs(value - 1);
  }

  // Clamp the opacity value between 0 and 1
  const opacity = Math.max(0, Math.min(deviation, 1));

  return opacity;
};

const GREEN_COLOR = '#50C878';
const RED_COLOR = '#FF5733';

// render a different background color for ratio cells.
export const renderCellBackground = (
  columnType: CohortSampleTableColumnType,
  value: string,
) => {
  if (columnType === CohortSampleTableColumnType.Ratio) {
    const numValue = parseFloat(value);
    const opacity = getOpacityBasedOnDeviation(numValue);

    const selectedColor = numValue >= 1 ? GREEN_COLOR : RED_COLOR;

    return colorAlpha(selectedColor, opacity);
  }
};

// formats any numerical number in a string to the same string
// with the number comma-ized
export const formatTextWithNumberValue = (text: string | null) => {
  if (isNil(text)) {
    return '';
  }

  return text.replace(/\b\d+\b/g, (match) => {
    return formatNumberWithComma(match).toString();
  });
};

// KB-7719
// super annoying issue on Safari that detect phone number and make it clickable,
// <meta /> tag doesn't work. therefore added "" symbol to prevent it
// https://stackoverflow.com/questions/226131/how-to-disable-phone-number-linking-in-mobile-safari
export const displayTextWithEmptySymbol = (text: string) => {
  return <>{text}&zwj;</>;
};
